import React from "react";
import "../styles/loader.css";

export const Loader = () => {
  return <div className="loader loader_bubble"></div>;
};
